import styled from 'styled-components';
import { ASSETS } from '../../../../../assets';

export const TrialWillEndIcon = styled(ASSETS.COLORED_LIGHTNING)`
  width: 42px;
  height: 74px;
`;
